import { Box } from "@mui/material";
import { Filter } from "pepsico-ds";
import React, { useState } from "react";
import { getDropDownOptionValuesForCuratorFilters } from "../../utils/function";
import { useSelector } from "react-redux";
import { CURATOR_PAGE_API_CONSTANT } from "../../constant/constant";
import "./CustomCuratorFilter.css";

const CustomCuratorFilter = ({ pageName, updatedFilterValue }) => {
  const isDarkTheme = useSelector((state) => state.theme);
  const filters = useSelector((state) => state.internalFilter);

  const [filterValues, setFilterValues] = useState({
    sector: null,
    country: null,
    subject: null,
    period: null,
    contentType: null,
    visibility: null,
    contentLevel: null,
  });
  const [countriesOptions, setCountriesOptions] = useState();
  const periods = [
    { id: 1, label: "Next 30 days" },
    { id: 2, label: "Next 60 days" },
    { id: 3, label: "Next 90 days" },
    { id: 4, label: "Past due" },
  ];
  const contentTypeOptions = [
    { id: 1, label: "Document" },
    { id: 2, label: "Link" },
    { id: 3, label: "Video" },
  ];

  const handleChange = (type) => (e) => {
    let newValue = e;
    if (filterValues[type]?.id === e?.id) {
      newValue = null;
    }
    if (type === "sector") {
      if (newValue) setCountriesOptions(filters?.sectorAndCountry[e?.label]);
      else setCountriesOptions(filters?.countryFilter);
    }
    setFilterValues((prev) => ({
      ...prev,
      [type]: newValue ?? [],
      ...(type === "sector" ? { country: [] } : {}),
    }));
    updatedFilterValue(newValue?.label ?? null, type);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        width: "100%",
        flexWrap: "wrap",
      }}
    >
      {(pageName === CURATOR_PAGE_API_CONSTANT.pending_approval ||
        pageName === CURATOR_PAGE_API_CONSTANT.yearly_review) && (
        <>
          <Filter
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Subjects
              </span>
            }
            value={filterValues.subject}
            onChange={handleChange("subject")}
            options={getDropDownOptionValuesForCuratorFilters(
              filters?.subjectFilter
            )}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />

          <Filter
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Sector
              </span>
            }
            value={filterValues.sector}
            onChange={handleChange("sector")}
            options={getDropDownOptionValuesForCuratorFilters(
              filters?.sectorFilter
            )}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />

          <Filter
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Country
              </span>
            }
            value={filterValues.country}
            onChange={handleChange("country")}
            options={getDropDownOptionValuesForCuratorFilters(
              countriesOptions ?? filters?.countryFilter
            )}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />
        </>
      )}
      {pageName === CURATOR_PAGE_API_CONSTANT.yearly_review && (
        <Filter
          label={
            <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
              Period
            </span>
          }
          value={filterValues.period}
          onChange={handleChange("period")}
          options={periods}
          selection="single"
          size="medium"
          isDark={isDarkTheme}
        />
      )}
      {(pageName === CURATOR_PAGE_API_CONSTANT.artificat_history ||
        pageName === CURATOR_PAGE_API_CONSTANT.denied_history) && (
        <>
          <Filter
            className="curator-articats-history"
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Content type
              </span>
            }
            value={filterValues.contentType}
            onChange={handleChange("contentType")}
            options={contentTypeOptions}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />

          <Filter
            className="curator-articats-history"
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Visibility
              </span>
            }
            value={filterValues.visibility}
            onChange={handleChange("visibility")}
            options={getDropDownOptionValuesForCuratorFilters(
              filters?.visibility
            )}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />

          <Filter
            className="curator-articats-history"
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Content level
              </span>
            }
            value={filterValues.contentLevel}
            onChange={handleChange("contentLevel")}
            options={getDropDownOptionValuesForCuratorFilters(
              filters?.contentLevel
            )}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />
        </>
      )}
    </Box>
  );
};

export default CustomCuratorFilter;
